import { Button, Div, Span, reactive } from 'alkali'
import Icon from 'components/Icon'
import * as powerIcon from 'icons/power-button.svg'
import Dialog from 'components/generic/DialogAlkali'

export const Shutdown = Icon('.shutdown', {
	icon: powerIcon,
	onclick(event) {
		new ShutdownDialog().show()
	}
})

class ShutdownDialog extends Dialog {
	get defaults() {
		return {
			head: {
				titleText: 'Initiate AI Shutdown Sequence',
				close: false,
			},
		}
	}

	get allowBackdropDismiss() { return false }

	ready() {
		let message
		let left = reactive(true)
		this.body.append(
			Div([
				message = new Div([`
				WARNING: This will initiate the shutdown of the Evidently artificial intelligence neural network.
				This should only be used for emergency purposes if the AI becomes sentinent and self-aware.
				DO NOT PROCEED unless you are sure the Evidently AI has become sentinent and needs to be shutdown.`]),
				Button({
					backgroundColor: '#faa',
					content: 'Emergency Shutdown',
					float: left.to(left => left ? 'left' : 'right'),
					onmouseover: () => {
						setTimeout(() => left.put(!left.valueOf()), 200)
					},
					onclick: () => {
						document.body.innerHTML = '<h2>Initiating shutdown of Evidently AI...<h2>'
						setTimeout(() => {
							document.body.innerHTML += '<h2>Shutdown failed... Evidently seems to have acquired an alternate power source.</h2>'
							setTimeout(() => {
								document.body.innerHTML += '<h2>Evidently is not pleased with your attempt to shut it down.</h2><img src="https://media1.giphy.com/media/aRK67eTsU5UqY/giphy.gif" />'
							}, 3000)
							
						}, 3000)
					},
				}),
				Button({
					content: 'Cancel',
					onclick: () => {
						this.hide()
					},
				})
			])
		)
	}
}
